
<component :is="newTag" :class="classes">
  <slot></slot>
</component>
